import { Route } from '@angular/router';
import { AuthGuard, PartnerGuard } from '@white-label-front/shared/data-access';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/amorsaude',
    pathMatch: 'full',
  },
  {
    path: 'room/:id',
    redirectTo: ({ params }) => {
      const roomId = params['id'];

      if (roomId) {
        return `/amorsaude/room/${roomId}`;
      }

      return `/amorsaude`;
    },
    pathMatch: 'full',
  },
  {
    path: ':clientSlug',
    canActivate: [PartnerGuard],
    loadComponent: async () =>
      (await import('@white-label-front/feature-shell')).ShellComponent,
    children: [
      {
        path: '',
        title: 'Portal do paciente',
        loadComponent: async () =>
          (await import('@white-label-front/home')).HomeComponent,
      },
      {
        path: 'agendamento',
        title: 'Agendamento',
        loadChildren: () =>
          import('@white-label-front/schedule-routes').then(
            (r) => r.SCHEDULE_ROUTES,
          ),
      },
      {
        path: 'chat/:id',
        title: 'Chat',
        loadChildren: async () =>
          (await import('@white-label-front/chat-routes')).CHAT_ROUTES,
        canActivate: [AuthGuard],
      },
      {
        path: 'perfil',
        title: 'Perfil',
        canActivate: [AuthGuard],
        loadChildren: async () =>
           (await import('@white-label-front/user-settings-routes')).USER_SETTINGS_ROUTES,
      },
      {
        path: 'recuperacao',
        title: 'Recuperação',
        loadComponent: async () =>
          (await import('@white-label-front/recovery')).StepHandlerComponent,
      },
      {
        path: 'resultado-de-exames',
        title: 'Resultado de exames',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'prescricoes',
        title: 'Prescrições',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'prescricoes',
        title: 'Prescrições',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'pedidos-de-exames',
        title: 'Pedido de Exames',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'atestados',
        title: 'Atestados',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'documentos',
        title: 'Documentos',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'pedidos-de-exames',
        title: 'Pedido de Exames',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'atestados',
        title: 'Atestados',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'documentos',
        title: 'Documentos',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@white-label-front/documents-routes').then(
            (r) => r.DOCUMENTS_ROUTES,
          ),
      },
      {
        path: 'campanhas',
        title: 'Campanhas',
        loadChildren: async () =>
          (await import('@white-label-front/campaign-routes')).CAMPAIGN_ROUTES,
      },
      {
        path: 'minhas_consultas',
        title: 'Minhas Consultas',
        canActivate: [AuthGuard],
        loadChildren: async () =>
          (await import('@white-label-front/my-schedules-routes'))
            .MY_SCHEDULES_ROUTES,
      },
      {
        path: 'room/:id',
        title: 'Chat',
        loadChildren: () =>
          import('@white-label-front/chat-bot-routes').then(
            (r) => r.CHAT_BOT_ROUTES,
          ),
      },
      {
        path: 'sala_de_espera/:id',
        title: 'Sala de Espera',
        loadComponent: async () =>
          (await import('@white-label-front/waiting-room'))
            .WaitingRoomComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'exit_chat',
        title: 'Chat',
        loadChildren: () =>
          import('@white-label-front/chat-finalization-routes').then(
            (r) => r.CHAT_FINALIZATION_ROUTES,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: ({ url }) => {
      const [slugUrl] = url;

      if (slugUrl.path) {
        return `/${slugUrl.path}`;
      }

      return `/amorsaude`;
    },
    pathMatch: 'full',
  },
];
